export const createProfileForAccount = (account) => {
  return { id: account.id, displayName: account.displayName || account.id, avatar: account.avatar || '' };
};
